import React, { Component } from "react";
import {Card,CardHeader,CardBody,Box,HStack,FormControl,FormLabel,Select,Text,Center} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import CoreService from "../../services/CoreService";
import OrgConfigDetailCard from "./Components/OrgConfigDetailCard";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";

export default class ObsSchemaMgmtPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgConfig: null,
      orgConfigJson: null,
      isLoading: faBullseye
    };

    this.coreService = new CoreService();


  }

  async componentDidMount() {
    var orgConfigResult = await this.coreService.fetchOrgConfiguration(this.props.userSession.gcid, this.props.userSession.token);
    if (orgConfigResult.hasError) {
      this.props.onErrorPageRequest("Error fetching Org Configuration.");
      return;
    }
    this.setState({
      orgConfig: orgConfigResult.dataResult,
      orgConfigJson: orgConfigResult.dataResult
    });
  }



  render() {
    const loadingIcon = this.state.isLoading ? (
      <FontAwesomeIcon icon="sync-alt" color="green" spin />
    ) : (
      ""
    );

    return (
      (this.state.orgConfig) ?
        <div className='main'>
          <Box bgColor='#0a597e' borderRadius='5px' width='100%' padding='20px'>

            <Text fontSize={{ base: '30px', md: '36px', lg: '40px' }} color='white'>Org Configuration Viewer</Text>

            {(this.state.orgConfigJson) ?

              <Box>
                <OrgConfigDetailCard
                  userSession={this.props.userSession}
                  orgConfigJson={this.state.orgConfigJson}
                />
              </Box>

              : <span />}

          </Box>
        </div>
        : <span />
    );
  }
}
